// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentBrief-module__root___VSGIA {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.AppointmentBrief-module__header___jL9SW {
  padding: 20px;
}

.AppointmentBrief-module__name___P2A0P {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #18181b;
}

.AppointmentBrief-module__demographics___nfTDv {
  font-size: 14px;
  font-weight: 400;
  color: #71717a;
}

.AppointmentBrief-module__visitLine___GTqA5 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 8px 0 0;
  font-size: 14px;
  color: #3f3f46;
}

.AppointmentBrief-module__dot___bYXtj {
  width: 9px;
  height: 9px;
  flex-shrink: 0;
  border-radius: 999px;
}

.AppointmentBrief-module__visitType___I2ola {
  font-weight: 600;
  color: #18181b;
}

.AppointmentBrief-module__separator___Mcqi5 {
  color: #a1a1aa;
}

.AppointmentBrief-module__lastMoca___e0LiM {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
  margin: 8px 0 0;
  font-size: 14px;
  color: #71717a;
}

.AppointmentBrief-module__actions___Lk7My {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.AppointmentBrief-module__actionButton___oxfOG {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #18181b;
  text-decoration: none;
}
.AppointmentBrief-module__actionButton___oxfOG:hover {
  border-color: #18181b;
  color: #18181b;
}

.AppointmentBrief-module__actionIcon___tOsM2 {
  color: #71717a;
}

.AppointmentBrief-module__actionDisabled___g_rVc {
  border-style: dashed;
  background: #fafafa;
  color: #a1a1aa;
  cursor: default;
}
.AppointmentBrief-module__actionDisabled___g_rVc:hover {
  border-color: #d4d4d8;
  color: #a1a1aa;
}

.AppointmentBrief-module__actionError___IObjl {
  align-self: center;
  font-size: 13px;
  color: #991b1b;
}

.AppointmentBrief-module__root___VSGIA {
  container-type: inline-size;
}

.AppointmentBrief-module__shortLabel___KMUH0 {
  display: none;
}

@container (max-width: 639px) {
  .AppointmentBrief-module__header___jL9SW {
    padding: 14px;
  }
  .AppointmentBrief-module__name___P2A0P {
    font-size: 18px;
  }
  .AppointmentBrief-module__actions___Lk7My {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
  }
  .AppointmentBrief-module__actionButton___oxfOG {
    justify-content: center;
    padding: 6px 8px;
  }
  .AppointmentBrief-module__fullLabel____4tIW {
    display: none;
  }
  .AppointmentBrief-module__shortLabel___KMUH0 {
    display: inline;
  }
}
.AppointmentBrief-module__mocaPrompt___TK92P {
  margin-top: 13px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/AppointmentBrief.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AACF;AACE;EACE,qBAAA;EACA,cAAA;AACJ;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,qBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AADF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE;IACE,aAAA;EAAF;EAGA;IACE,eAAA;EADF;EAIA;IACE,aAAA;IACA,gDAAA;IACA,QAAA;EAFF;EAKA;IACE,uBAAA;IACA,gBAAA;EAHF;EAMA;IACE,aAAA;EAJF;EAOA;IACE,eAAA;EALF;AACF;AAQA;EACE,gBAAA;AANF","sourcesContent":[".root {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.header {\n  padding: 20px;\n}\n\n.name {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.demographics {\n  font-size: 14px;\n  font-weight: 400;\n  color: #71717a;\n}\n\n.visitLine {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #3f3f46;\n}\n\n.dot {\n  width: 9px;\n  height: 9px;\n  flex-shrink: 0;\n  border-radius: 999px;\n}\n\n.visitType {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.separator {\n  color: #a1a1aa;\n}\n\n.lastMoca {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 10px;\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #71717a;\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.actionButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #18181b;\n  text-decoration: none;\n\n  &:hover {\n    border-color: #18181b;\n    color: #18181b;\n  }\n}\n\n.actionIcon {\n  color: #71717a;\n}\n\n.actionDisabled {\n  border-style: dashed;\n  background: #fafafa;\n  color: #a1a1aa;\n  cursor: default;\n\n  &:hover {\n    border-color: #d4d4d8;\n    color: #a1a1aa;\n  }\n}\n\n.actionError {\n  align-self: center;\n  font-size: 13px;\n  color: #991b1b;\n}\n.root {\n  container-type: inline-size;\n}\n\n.shortLabel {\n  display: none;\n}\n\n@container (max-width: 639px) {\n  .header {\n    padding: 14px;\n  }\n\n  .name {\n    font-size: 18px;\n  }\n\n  .actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 6px;\n  }\n\n  .actionButton {\n    justify-content: center;\n    padding: 6px 8px;\n  }\n\n  .fullLabel {\n    display: none;\n  }\n\n  .shortLabel {\n    display: inline;\n  }\n}\n\n.mocaPrompt {\n  margin-top: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AppointmentBrief-module__root___VSGIA`,
	"header": `AppointmentBrief-module__header___jL9SW`,
	"name": `AppointmentBrief-module__name___P2A0P`,
	"demographics": `AppointmentBrief-module__demographics___nfTDv`,
	"visitLine": `AppointmentBrief-module__visitLine___GTqA5`,
	"dot": `AppointmentBrief-module__dot___bYXtj`,
	"visitType": `AppointmentBrief-module__visitType___I2ola`,
	"separator": `AppointmentBrief-module__separator___Mcqi5`,
	"lastMoca": `AppointmentBrief-module__lastMoca___e0LiM`,
	"actions": `AppointmentBrief-module__actions___Lk7My`,
	"actionButton": `AppointmentBrief-module__actionButton___oxfOG`,
	"actionIcon": `AppointmentBrief-module__actionIcon___tOsM2`,
	"actionDisabled": `AppointmentBrief-module__actionDisabled___g_rVc`,
	"actionError": `AppointmentBrief-module__actionError___IObjl`,
	"shortLabel": `AppointmentBrief-module__shortLabel___KMUH0`,
	"fullLabel": `AppointmentBrief-module__fullLabel____4tIW`,
	"mocaPrompt": `AppointmentBrief-module__mocaPrompt___TK92P`
};
module.exports = ___CSS_LOADER_EXPORT___;
